import { render } from "./SearchInputTextComponent.vue?vue&type=template&id=480c6aee&scoped=true"
import script from "./SearchInputTextComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchInputTextComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchInputTextComponent.vue?vue&type=style&index=0&id=480c6aee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480c6aee"]])

export default __exports__